// /var/www/afra/web-design.rampagesoft.com/my-app/src/component/Service.js
// src/component/Service.js
import React from 'react';
import serviceData from '../data/serviceData.json';
import '../css/Service.scss';

// Utility helper for image URLs
const buildImageUrl = (path = '') => {
  if (/^https?:\/\//i.test(path)) {
    return path; // Full external URL
  }
  return `${process.env.PUBLIC_URL}${path.startsWith('/') ? '' : '/'}${path}`;
};

const Service = ({ Swiper, SwiperSlide, swiperConfig }) => {
  return (
    <section className="service-section">
      <h2 className="service-title animate-fade-in">บริการของเรา</h2>
      <Swiper
        {...swiperConfig}
        style={{ width: '100%', height: 'auto', minHeight: '400px' }}
      >
        {serviceData.length > 0 ? (
          serviceData.map((item, index) => (
            <SwiperSlide
              key={`service-${item.id}-${index}`}
              className="service-slide"
            >
              <div
                className="service-card"
                style={{
                  backgroundImage: `url(${buildImageUrl(item.image)})`,
                  backgroundSize: 'cover',
                  backgroundPosition: 'center',
                  width: '100%',
                  height: '400px',
                }}
              >
                <div className="service-overlay">
                  <h3 className="animate-text">{item.title}</h3>
                  <p className="animate-text">{item.description}</p>
                  <a href={item.link} className="service-button animate-text">
                    ขยายธุรกิจกับเรา
                  </a>
                </div>
              </div>
            </SwiperSlide>
          ))
        ) : (
          <div>No services available to display.</div>
        )}
      </Swiper>
    </section>
  );
};

export default Service;
